import { useNavigate, useParams } from "react-router-dom";
import Icon from "../../components/Icon";
import ROUTES from "../../routes";
import { Tabs } from "antd";
import ServiceCenter from "../SerialNo/ServiceCenter";
import ServiceType from "../SerialNo/ServiceType";
import CompanyUser from "../CompanyUser";
import { useLazyGetCompanyQuery } from "../../services/company";
import { useEffect } from "react";
import { LoadingOutlined } from "@ant-design/icons";

const CompanyDetail = () => {
    const navigate = useNavigate();
    const { companyId } = useParams();
    const [getCompany, getCompanyResult] = useLazyGetCompanyQuery();
    useEffect(() => {
        if (companyId !== null && companyId !== "00000000-0000-0000-0000-000000000000") {
            getCompany({ id: companyId }).unwrap();
        }
    }, [companyId]);

    const tabItems = [];
    if (companyId !== null && companyId !== "00000000-0000-0000-0000-000000000000") {
        tabItems.push(
            {
                key: "1",
                label: "Service Centers",
                children: <ServiceCenter companyId={companyId} insideTab={true} />
            },
            {
                key: "2",
                label: "Service Types",
                children: <ServiceType companyId={companyId} insideTab={true} />
            },
            {
                key: "3",
                label: "Users",
                children: <CompanyUser presentation={"User"} insideTab={true} />
            }
        );
    } else {
        tabItems.push({
            key: "3",
            label: "Users",
            children: <CompanyUser presentation={"User"} insideTab={true} />
        });
    }

    return (
        <>
            <div className="flex gap-x-2 items-center pb-2">
                <Icon
                    icon="arrow_back"
                    className="h-5 w-5 cursor-pointer"
                    onClick={() => navigate(ROUTES.PATHS.DEVELOPER_COMPANIES)}
                />
                <div className="text-headline">Company Details</div>
            </div>
            {getCompanyResult.isFetching && <LoadingOutlined className="text-primary" style={{ fontSize: 34 }} />}
            {getCompanyResult.isSuccess && <div className="flex items-center gap-x-3">
                <div className="text-[17px] font-semibold">
                    {`${getCompanyResult.data.name || ""}`}
                </div>
                <div className="text-xs opacity-80">
                    {getCompanyResult.data.mobileNo}
                </div>
                <div className="text-[13px] text-primary font-medium">
                    {getCompanyResult.data.email}
                </div>
                <div>
                    {getCompanyResult.data.isActive === true ? "Active" : "Inactive"}
                </div>
            </div>}
            <div className="space-y-3 pb-10">
                <Tabs items={tabItems} />
            </div>
        </>
    )
};

export default CompanyDetail;